import AsyncStorage from "@react-native-async-storage/async-storage";
import * as SecureStore from "expo-secure-store";
import { TenantSubdomain } from "features/types";

type StoredAuth = {
  username: string;
  id: string | number;
};

export const authKey = "auth";
export const themeKey = "theme";
export const subdomainKey = "subdomain";
const tokenKey = "token";

async function parseAsyncStorageItem<T = void>(key: string): Promise<T | null> {
  try {
    const value = await AsyncStorage.getItem(key);
    return value ? (JSON.parse(value) as T) : null;
  } catch {
    await AsyncStorage.removeItem(key);
    return null;
  }
}
export const setStoredAuth = (value: StoredAuth) =>
  AsyncStorage.setItem(authKey, JSON.stringify(value));

export const getStoredAuth = () => parseAsyncStorageItem<StoredAuth>(authKey);

export const saveSecureToken = (value: string = "") =>
  SecureStore.setItemAsync(tokenKey, value);

export const getSecureStoredToken = async () => {
  return SecureStore.getItemAsync(tokenKey);
};

export const deleteSecureStoredToken = () =>
  SecureStore.deleteItemAsync(tokenKey);

export const getStoredTenantSubdomain = () =>
  parseAsyncStorageItem<{ subdomain: TenantSubdomain }>(subdomainKey);

export const setStoredTenantSubdomain = (value: TenantSubdomain) =>
  AsyncStorage.setItem(subdomainKey, JSON.stringify({ subdomain: value }));

export const removeStoredTenantSubdomain = () =>
  AsyncStorage.removeItem(subdomainKey);

export const setAutoReservePopup = (value: boolean) =>
  AsyncStorage.setItem("autoReservePopup", JSON.stringify(value));

export const getAutoReservePopup = () =>
  parseAsyncStorageItem<boolean>("autoReservePopup");
